<template>
  <div id="app">
    <!-- Preloader -->
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <!-- Preloader end -->

    <router-view name="navbar"></router-view>
    <router-view />
    <vue-progress-bar></vue-progress-bar>

    <GlobalToast ref="globalToast" />
    <Fab />
    <!-- Application version -->
    <div class="version-info">Version: {{ version }}</div>
  </div>
</template>

<script>
import $ from "jquery";
import GlobalToast from "./components/GlobalToast.vue";
import ToastPlugin from "./plugins/toast";
import Fab from "./components/Fab.vue";
export default {
  name: "App",
  components: {
    GlobalToast,
    Fab,
  },
  data() {
    return {
      // version: '2.2.3'
      version: "3.2.0",
    };
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
    this.loader();
    this.$toast._setInstance(this.$refs.globalToast);
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  methods: {
    loader() {
      $(".loader-wrapper").fadeOut("slow", function () {
        $(this).remove(); // Hapus elemen setelah animasi selesai
      });
    },
  },
};
</script>

<style scoped>
/* Styling untuk menempatkan versi di kanan bawah */
.version-info {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-family: Arial, sans-serif;
  z-index: 9999; /* Agar tetap di atas elemen lain */
}
</style>



// WEBPACK FOOTER //
// src/App.vue